module.exports = __webpack_public_path__ + "static/media/escoriacao_inicial.19385a15.jpeg";